export default __webpack_public_path__ + "static/media/JohnFrancis.983a6c8d.jpg";